import React, { useState, useEffect } from "react";
import { Row, Col, Form, Select, message } from "antd";
import {
  CustomButton,
  CustomSecondaryButton,
} from "../../pages/physician_page/styled";
import AddPhysicianModalWrapper from "../../modal/AddPhysicianModalWrapper";
import { physicianService } from "../../../services/user";
import videos from "../../../services/videos";
import { notify } from "../../../utils/helper";
import ModelWrapper from "../../modal/ModelWrapper";

const { Option } = Select;

const AssignVideoModal = ({ 
  isOpen, 
  setOpen, 
  onConfirm, 
  onClose, 
  selectedVideos,
  setSelectedRowKeys,
  fetchVideos,
}) => {
  const [form] = Form.useForm();
  const [physicians, setPhysicians] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const fetchPhysicians = async () => {
    if (!isOpen) return;
    
    try {
      setLoading(true);
      const response = await physicianService.getAll();
      if (response?.data?.results) {
        setPhysicians(response.data.results);
        // console.log(response.data.results);
      } else {
        setPhysicians([]);
        notify("error","Failed to load physicians data")
      }
    } catch (error) {
      notify("error",'Failed to load physicians')
      setPhysicians([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    if (!values.physician || selectedVideos.length === 0) {
      notify('warning',"Please select both physician and videos");
      return;
    }

    try {
      setSubmitting(true);
      
     const res= await videos.assignVideos({
        physicianId: values.physician,
        videoIds: selectedVideos
      });
     
      notify('success',`Successfully assigned ${selectedVideos.length} video(s) to physician`);
      setSelectedRowKeys([]);
      if (onConfirm) {
        onConfirm(values.physician, selectedVideos);
      }
      fetchVideos();
      handleClose();
    } catch (error) {
      notify('error',"Failed to assign videos to physician");
    } finally {
      setSubmitting(false);
    }
  };

  const handleClose = () => {
    form.resetFields();
    if (onClose) {
      onClose();
    } else {
      setOpen(false);
    }
  };

  useEffect(() => {
    fetchPhysicians();
  }, [isOpen]);

  return (
    <ModelWrapper
      show={isOpen}
      setShow={setOpen}
      title={
        <div className="row-flex flex-column">
          <div className="font-18 font-semibold text-primary">
            Assign Video to Physician
          </div>
          {selectedVideos.length > 0 && (
            <div style={{fontSize:'16px',color:'var(--secondary-text-color)'}}>
              {selectedVideos.length} selected video(s)
            </div>
          )}
        </div>
      }
      footer={null}
      width={550}
      keyClose={false}
      onCancel={handleClose}
      className="custom-detail-modal"
    >
      <Form 
        form={form} 
        layout="vertical" 
        onFinish={handleSubmit}
      >
        <Row>
          <Col span={24}>
            <Form.Item
              name="physician"
              label="Physicians"
              rules={[{ required: true, message: "Please select a physician!" }]}
            >
              <Select
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                placeholder="Select Physician"
                showSearch
                loading={loading}
                size="large"
                filterOption={(input, option) =>
                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                notFoundContent={loading ? "Loading..." : "No physicians found"}
                disabled={submitting}
              >
                {physicians.map(physician => (
                  <Option
                    key={physician.id}
                    value={physician.id}
                    label={`${physician.name} : ${physician.specialty} - ${physician?.email}`}
                    style={{borderBottom: "1px solid var(--border-color)"}}
                  >
                 
                          {physician.name} : {physician.specialty} - {physician?.email}
                    
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={24} className="d-flex justify-end gap-12">
            <CustomSecondaryButton 
              onClick={handleClose}
              disabled={submitting}
            >
              Cancel
            </CustomSecondaryButton>
            <CustomButton 
              htmlType="submit"
              loading={submitting}
              disabled={selectedVideos.length === 0}
            >
              {submitting ? "Assigning..." : "Assign"}
            </CustomButton>
          </Col>
        </Row>
      </Form>
    </ModelWrapper>
  );
};

export default AssignVideoModal;